/**
 * Shortcut for querySelector. Can fail but for type convenience returns HTMLElement ( actual return is Element|Undefined )
*
* @param {string} selector
* @param {HTMLElement|Document} context
*
* @return {HTMLElement|undefined}
*/
export function get( selector, context = document ) {
    return context.querySelector( selector );
}
/**
 * Shortcut for querySelectorAll. Can fail but for type convenience returns HTMLElement ( actual return is Element|Undefined )
 *
 * @param {string} selector
 * @param {HTMLElement|Document} context
 *
 * @return {NodeListOf<HTMLElement>}
 */
export function getAll( selector, context = document ) {
    return context.querySelectorAll( selector );
}
/**
 * Shortcut for getElementByID. Can fail but for type convenience returns HTMLElement ( actual return is Element|Undefined )
 *
 * @param mixed tagName

 * @return {HTMLElement|undefined}
 */
export function getById( id ) {
    return document.getElementById( id );
}
/**
 *
 * @param mixed tagName

 * @return {HTMLCollectionOf<HTMLElement>}
 */
export function getByTag( tagName ) {
    return document.getElementsByTagName( tagName );
}